export const addLeadingZero = (value: number): string => (value >= 10 ? `${value}` : `0${value}`);
